import { Component } from 'react';
import PropTypes from 'prop-types';

export default class FormField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined,
      checked: undefined,
    };
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value && this.props.onValidate) {
      this.validate(nextProps.value);
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  onBlur(e) {
    if (this.props.onBlur) this.props.onBlur(e);
  }

  get pattern() {
    return /(?:)/;
  }

  validate(value) {
    const error = this.hasError(value);
    const checked = !value ? undefined : !error;
    if (this.state.error !== error) {
      this.props.onValidate(error, value, this.props);
    }
    this.setState({ error, checked });
  }

  hasError(value = '') {
    const hasValue = !!value;
    if (this.props.required) {
      return !hasValue || !this.isValid(value);
    }
    return hasValue ? !this.isValid(value) : false;
  }

  isValid(val) {
    return this.pattern.test(val);
  }
}

FormField.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onValidate: PropTypes.func,
  value: PropTypes.string,
  required: PropTypes.bool,
};
